module.exports = __webpack_public_path__ + "static/img/76051B_1_R_20201120_LC.148df8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/76051B_1_R_20201120_LC.png
// module id = NK2b
// module chunks = 0